import { action } from 'satcheljs';

export default action('ADD_NEW_MAILBOX_DEFAULT_FAVORITES');
